import React from "react";
import ChangePassword from "../../components/Auth/ChangePassword";
import { useNavigate } from "react-router-dom";

const ChangePasswordPage = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/");
  };

  return <ChangePassword onSuccess={handleSuccess} />;
};

export default ChangePasswordPage;
